const faqs = [
  {
    q: '91麻豆免费视频网站需要注册才能观看吗？',
    a: '不需要注册即可观看。91麻豆免费视频网站秉承开放共享理念，所有91高清视频在线资源均可直接在线观看，无需注册账号，无需登录，打开网站即可畅享超清视频在线观看体验。',
  },
  {
    q: '网站的视频画质如何？播放会卡顿吗？',
    a: '全站视频均支持1080P超清画质播放。采用先进的H.265编码技术与智能CDN加速网络，根据您的网络环境自动匹配最佳码率，在WiFi环境下可畅享超清画质，移动网络下也能流畅播放不卡顿。',
  },
  {
    q: '91高清视频在线内容多久更新一次？',
    a: '我们的内容团队全天候运营，确保91高清视频在线资源每日更新。热门分类和精选专题更是保持高频上新节奏，让您每次访问都能发现新的精彩内容，永不错过任何热门视频。',
  },
  {
    q: '支持哪些设备观看？需要安装播放器吗？',
    a: '91麻豆免费视频网站采用HTML5标准播放器，无需安装任何插件或APP。完美支持Windows、Mac、iOS、Android等主流操作系统，电脑、手机、平板均可流畅观看，真正做到随时随地高清在线。',
  },
  {
    q: '网站的内容资源主要有哪些分类？',
    a: '平台涵盖91国产高清视频、超清视频在线观看、高清影视在线等多个分类，并设有热门精选、每日更新、专题推荐等多个内容板块。无论您偏好哪种类型，都能在这里找到心仪的高清视频内容。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            关于91麻豆免费视频网站的常见疑问，这里为您一一解答
          </p>
        </div>
        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="text-base font-heading font-semibold text-foreground-950 mb-3">
                <span className="text-primary-500 mr-2">Q{idx + 1}.</span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}